var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	9298: {
		fallback: () => (() => (__webpack_require__(961))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	6158: {
		fallback: () => (() => (__webpack_require__(6540))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	1685: {
		fallback: () => (() => (__webpack_require__(4848))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	95: {
		fallback: () => (() => (__webpack_require__(5338))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react-dom/client",

	},
	4851: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(8112))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	9910: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(2040))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@tanstack/react-query",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [9298,6158];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"685": [
		1685
	],
	"792": [
		9298,
		6158
	],
	"906": [
		95,
		4851,
		9910
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}